/* =============================
Arknights: Endfield (Kikiyx) Catalog
Auto-generated from config
Pattern: unified
============================= */
(function () {
  const API_SOURCES = {
    'kikiyx': {
      name: 'Kikiyx',
      enabled: true,
      priority: 1,
      idPrefix: '',
      prefixes: [],
      unwanted: new Set(['亚服', '美欧', '女角色', '男角色']),
      nameKey: 'name',
      idKey: 'id',
      imageKey: 'img_url',
      root: 'results'
    }
  };

  // Uses the deployed wuwa-multi-proxy with source=ake (targets kikiyx.cn/zmd/ for Arknights: Endfield)
  const KIKIYX_BASE = 'https://nodejs-serverless-function-express-delta-ten-11.vercel.app/api/wuwa-multi-proxy?source=ake';
  let selected = {}; // Keyed by Display Name

  // Lazy Loading State
  let allSearchResults = [];
  let renderedCount = 0;
  const BATCH_SIZE = 24;
  let resultObserver = null;

  const initResultObserver = () => {
    if (resultObserver) resultObserver.disconnect();
    resultObserver = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting && renderedCount < allSearchResults.length) { renderBatch(); }
    }, { rootMargin: '200px' });
  };

  const updateSelectedUI = () => {
    const totalCount = Object.values(selected).reduce((sum, sel) => sum + (sel.count || 0), 0);
    const el = document.querySelector("#selectedCount");
    if (el) el.textContent = totalCount;
  };

  const scrollToResults = () => {
    document.querySelector("#results")?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const showToast = () => {
    const toast = document.querySelector("#toast");
    if (!toast) return;
    toast.classList.remove('hidden', 'show');
    toast.offsetHeight;
    toast.classList.add('show');
    setTimeout(() => { toast.classList.remove('show'); setTimeout(() => toast.classList.add('hidden'), 300); }, 3000);
  };

  const copyToClipboard = text => {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(text).then(showToast).catch(() => fallbackCopy(text));
    } else fallbackCopy(text);
  };

  const fallbackCopy = text => {
    const ta = document.createElement('textarea');
    ta.value = text; ta.style.cssText = 'position:fixed;left:-9999px';
    document.body.appendChild(ta); ta.select();
    try { document.execCommand('copy'); showToast(); } catch (e) { }
    document.body.removeChild(ta);
  };

  const escapeHtml = s => String(s || '').replace(/[&<>"']|'/g, m => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
  }[m]));

  /*====== Settings & Translations ======*/
  let appSettings = {
    translations_json: '{}', images_json: '{}', api_toggles: {},
    api_priority: {}
  };

  const logger = {
    log: (...args) => { if (appSettings.enable_debug) console.log(...args); },
    warn: (...args) => { if (appSettings.enable_debug) console.warn(...args); },
    error: (...args) => { console.error(...args); } // Errors always show
  };

  try {
    const el = document.getElementById('catalog-settings-kikiyx-ake-v1');
    if (el) appSettings = JSON.parse(el.textContent);

    if (appSettings.api_toggles) {
      Object.keys(API_SOURCES).forEach(apiId => {
        if (appSettings.api_toggles.hasOwnProperty(apiId)) {
          API_SOURCES[apiId].enabled = appSettings.api_toggles[apiId] === true;
        }
        if (appSettings.api_names && appSettings.api_names[apiId]) {
          API_SOURCES[apiId].name = appSettings.api_names[apiId];
        }
        if (appSettings.api_priority && appSettings.api_priority.hasOwnProperty(apiId)) {
          API_SOURCES[apiId].priority = parseInt(appSettings.api_priority[apiId], 10);
        }
      });
    }
  } catch (e) { }

  let nameTranslationsMap = {};
  try {
    const json = JSON.parse(appSettings.translations_json || '{}');
    Object.entries(json).forEach(([key, val]) => {
      const standardValue = typeof val === 'string' ? val.trim() : val;
      key.split('|').forEach(k => { if (k.trim()) nameTranslationsMap[k.trim()] = standardValue; });
    });
  } catch (e) { }

  let customImagesMap = {};
  try {
    const json = JSON.parse(appSettings.images_json || '{}');
    Object.entries(json).forEach(([key, val]) => {
      const imageUrl = typeof val === 'string' ? val.trim() : val;
      key.split('|').forEach(k => { if (k.trim()) customImagesMap[k.trim()] = imageUrl; });
    });
  } catch (e) { }

  const translateName = name => nameTranslationsMap[name] || name;
  const getCustomImage = name => customImagesMap[name] || null;

  function privateToPublicID(privateID, source) {
    if (!privateID) return '';
    const srcConf = API_SOURCES[source];
    const prefix = srcConf?.name ? srcConf.name.replace(/\s+/g, '') : 'ACC';
    return GachaUtils.obfuscateId(privateID, prefix);
  }

  function publicToPrivateID(publicID) {
    if (!publicID) return '';
    let core = publicID.trim();
    if (core.includes('----')) { core = core.split('----')[0]; }
    if (core.includes('-')) {
      core = core.split('-')[1];
    } else if (core.length > 5 && (core.startsWith('WW') || core.length > 12)) {
      if (core.length >= 5) core = core.substring(2, core.length - 2);
    }
    let chars = core.split('');
    for (let i = 0; i + 1 < chars.length; i += 2) { [chars[i], chars[i + 1]] = [chars[i + 1], chars[i]]; }
    return chars.reverse().join('');
  }

  const normalizeString = (name, prefixes) => {
    if (!name) return '';
    let n = String(name).trim();
    if (prefixes) prefixes.forEach(p => { if (n.startsWith(p)) n = n.slice(p.length); });
    return n;
  };

  const getResultsArray = (payload, apiId) => {
    if (!payload) return [];
    if (Array.isArray(payload)) return payload;

    const config = API_SOURCES[apiId];
    if (config && config.root) {
      const parts = config.root.split('.');
      let cur = payload;
      for (const p of parts) if (cur) cur = cur[p];
      if (Array.isArray(cur)) return cur;
    }

    return payload.results || payload.items || payload.data?.items || payload.data || (Array.isArray(payload.c) ? payload.c : []);
  };

  const updateThumbDisplay = (thumb, key) => {
    const count = selected[key]?.count || 0;
    const existingBadge = thumb.querySelector('.count-badge');
    if (count > 0) {
      thumb.classList.add('selected');
      if (existingBadge) existingBadge.textContent = count;
      else {
        const b = document.createElement('div');
        b.className = 'count-badge';
        b.textContent = count;
        thumb.querySelector('.thumb-img-container').appendChild(b);
      }
    } else {
      thumb.classList.remove('selected');
      if (existingBadge) existingBadge.remove();
    }
  };

  /* ====== Resource Loading ====== */
  const loadResources = () => {
    // ALWAYS log initial state regardless of enable_debug — for diagnostics
    console.log('[AKE DEBUG] loadResources() called');
    console.log('[AKE DEBUG] API_SOURCES.kikiyx.enabled =', API_SOURCES['kikiyx'].enabled);
    console.log('[AKE DEBUG] KIKIYX_BASE =', KIKIYX_BASE);

    logger.log('🚀 [Catalog] Initializing resource loading...');
    const resourcePromises = [];

    if (API_SOURCES['kikiyx'].enabled) {
      const url = KIKIYX_BASE + '&action=list';
      console.log('[AKE DEBUG] Fetching character list from:', url);
      logger.log('📡 [Catalog] Fetching Kikiyx characters:', url);

      resourcePromises.push(
        fetch(url)
          .then(r => {
            console.log('[AKE DEBUG] Proxy response status:', r.status, r.statusText);
            return r.json();
          })
          .then(data => {
            console.log('[AKE DEBUG] Raw proxy JSON response:', JSON.stringify(data).substring(0, 500));
            return data;
          })
          .catch(err => {
            console.error('[AKE DEBUG] Kikiyx fetch error:', err);
            logger.warn('⚠️ [Catalog] Kikiyx fetch failed:', err);
            return null;
          })
      );
    } else {
      console.log('[AKE DEBUG] Kikiyx API is DISABLED — check api_toggles in section settings');
      logger.log('🚫 [Catalog] Kikiyx is disabled.');
      resourcePromises.push(Promise.resolve(null));
    }

    Promise.all(resourcePromises).then(results => {
      logger.log('✅ [Catalog] All network requests complete.');
      let resultIdx = 0;
      const apiData = {};

      {
        const raw = results[resultIdx++];
        console.log('[AKE DEBUG] Processing raw data, type:', typeof raw, 'is null?', raw === null);
        logger.log('📦 [Catalog] Processing Kikiyx raw data:', raw);

        const dataArray = getResultsArray(raw, 'kikiyx');
        console.log('[AKE DEBUG] dataArray length (after getResultsArray):', Array.isArray(dataArray) ? dataArray.length : 'NOT AN ARRAY', dataArray);
        apiData['kikiyx'] = Array.isArray(dataArray) ? dataArray : [];
        logger.log('📊 [Catalog] Kikiyx processed items:', apiData['kikiyx'].length);

        const sMap = {};
        window._kikiyxServerMap = sMap;
      }

      const merged = {};

      if (apiData['kikiyx'] && apiData['kikiyx'].length > 0) {
        console.log('[AKE DEBUG] Starting merge loop, total items from API:', apiData['kikiyx'].length);
        console.log('[AKE DEBUG] First 5 API items:', JSON.stringify(apiData['kikiyx'].slice(0, 5)));
        logger.log('🖇️ [Catalog] Merging Kikiyx into registry...');

        // Use the configured prefixes and unwanted from API_SOURCES — no local shadow
        const prefixes = API_SOURCES['kikiyx'].prefixes || [];
        const unwanted = API_SOURCES['kikiyx'].unwanted;

        let filteredByType = 0;
        let filteredByUnwanted = 0;

        apiData['kikiyx'].forEach(item => {
          const rawName = item.name;
          const itemId = String(item.id || '');
          const itemType = item.type || (itemId.startsWith('A') ? 'server' : (itemId.startsWith('W') ? 'weapon' : 'character'));

          // Filter out ONLY server cards (A-prefix). Weapon cards (W-prefix) are now selectable.
          if (itemType === 'server') {
            filteredByType++;
            return;
          }

          const norm = normalizeString(rawName, prefixes);
          if (unwanted.has(norm)) {
            filteredByUnwanted++;
            return;
          }

          const displayLabel = translateName(norm);
          const itemImg = item.img_url || item.role_img || item.card_img || '';

          if (!merged[displayLabel]) {
            merged[displayLabel] = {
              displayLabel: displayLabel,
              normName: norm,
              rawNames: new Set([rawName, norm, displayLabel]),
              _kikiyx_id: itemId,
              img: itemImg
            };
          } else {
            merged[displayLabel]._kikiyx_id = itemId;
            if (!merged[displayLabel].img) merged[displayLabel].img = itemImg;
            merged[displayLabel].rawNames.add(rawName);
            merged[displayLabel].rawNames.add(norm);
          }
        });

        console.log('[AKE DEBUG] Merge complete — filteredByType:', filteredByType, ', filteredByUnwanted:', filteredByUnwanted, ', merged unique chars:', Object.keys(merged).length);
        console.log('[AKE DEBUG] Merged character keys:', Object.keys(merged));
      } else {
        console.warn('[AKE DEBUG] apiData[kikiyx] is EMPTY — proxy returned no items. This is the root cause of no character cards showing.');
      }

      let allItems = Object.values(merged);

      // Sort characters by character_order_source if set
      const orderSource = appSettings.character_order_source;
      if (orderSource && apiData[orderSource]) {
        logger.log('⚖️ [Catalog] Sorting characters by', orderSource, 'order...');
        const orderMap = new Map();
        const refItems = apiData[orderSource];
        const prefixes = API_SOURCES[orderSource].prefixes || [];
        const nKey = API_SOURCES[orderSource].nameKey || 'name';

        let rank = 0;
        refItems.forEach(item => {
          const raw = item[nKey] || item.name;
          if (!raw) return;
          const norm = normalizeString(raw, prefixes);
          const std = translateName(norm);
          if (!orderMap.has(std)) orderMap.set(std, rank++);
        });

        allItems.sort((a, b) => {
          const rankA = orderMap.has(a.displayLabel) ? orderMap.get(a.displayLabel) : 10000;
          const rankB = orderMap.has(b.displayLabel) ? orderMap.get(b.displayLabel) : 10000;
          if (rankA !== rankB) return rankA - rankB;
          return a.displayLabel.localeCompare(b.displayLabel);
        });
      }

      console.log('[AKE DEBUG] Final allItems count to render:', allItems.length);
      logger.log('🎨 [Catalog] Rendering', allItems.length, 'total unique characters.');

      window._characterImageMap = {};
      allItems.forEach(it => {
        if (it.img) window._characterImageMap[it.displayLabel] = it.img;
      });

      renderFilters(allItems);
    }).catch(e => {
      console.error('[AKE DEBUG] Critical merge error:', e);
      console.error('❌ [Catalog] Critical merge error:', e);
      document.querySelector("#filters").innerHTML = 'Failed to load character list. Check console for details.';
    });
  };

  /* ====== Filter Rendering ====== */
  const renderFilters = (items) => {
    const container = document.querySelector("#filters");
    if (!container) {
      console.error('[AKE DEBUG] #filters element NOT FOUND in DOM — check liquid template');
      return;
    }
    console.log('[AKE DEBUG] renderFilters() — rendering', items.length, 'character thumbs into #filters');
    container.innerHTML = '';

    if (items.length === 0) {
      container.innerHTML = '<div style="padding:20px;color:var(--text-muted,#aaa)">No character data loaded. Check browser console for [AKE DEBUG] logs.</div>';
      return;
    }

    items.forEach(it => {
      const thumb = document.createElement('div');
      const displayLabel = it.displayLabel;

      let imgSrc = getCustomImage(it.normName) || getCustomImage(it.displayLabel);
      if (!imgSrc) {
        for (let r of it.rawNames) {
          imgSrc = getCustomImage(r);
          if (imgSrc) break;
        }
      }
      const finalImg = imgSrc || it.img;

      thumb.className = 'thumb';
      thumb.dataset.kikiyxId = it._kikiyx_id || '';
      thumb.dataset.displayLabel = displayLabel;

      thumb.innerHTML = `<div class="thumb-img-container"><img alt="${displayLabel}" src="${finalImg || ''}"
              loading="lazy" /></div>
          <div class="label">${displayLabel}</div>`;

      thumb.onclick = () => {
        const key = thumb.dataset.displayLabel;
        if (selected[key]) {
          selected[key].count++;
        } else {
          selected[key] = {
            count: 1,
            kikiyxId: thumb.dataset.kikiyxId,
            rawNames: Array.from(it.rawNames)
          };
        }
        updateThumbDisplay(thumb, key);
        updateSelectedUI();
      };
      container.appendChild(thumb);
    });

    console.log('[AKE DEBUG] Finished rendering', items.length, 'character thumbs');
  };

  /* ====== SEARCH LOGIC ====== */
  const performSearch = () => {
    const selectedKeys = Object.keys(selected).filter(k => selected[k].count > 0);
    if (selectedKeys.length === 0) {
      alert("Please select at least one character before searching.");
      return;
    }

    console.log('[AKE DEBUG] performSearch() — selected keys:', selectedKeys, 'selected:', JSON.stringify(selected));

    const res = document.querySelector("#results");
    res.innerHTML = '<div class="no-data">Searching...</div>';
    scrollToResults();

    const serverSelect = document.querySelector("#serverSelect");
    const server = serverSelect ? serverSelect.value : '';
    const promises = [];

    if (API_SOURCES['kikiyx'].enabled) {
      const body = new URLSearchParams();
      selectedKeys.forEach(k => {
        if (selected[k].kikiyxId) {
          for (let i = 0; i < selected[k].count; i++)
            body.append('cards', selected[k].kikiyxId);
        }
      });
      if (server) body.append('server', server);

      console.log('[AKE DEBUG] POST body:', body.toString());
      promises.push(
        fetch(KIKIYX_BASE, {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: body.toString()
        })
          .then(r => r.json())
          .then(data => {
            console.log('[AKE DEBUG] Search response:', JSON.stringify(data).substring(0, 1000));
            return data;
          })
          .catch(() => ({ results: [] }))
      );
    } else promises.push(Promise.resolve({ results: [] }));

    Promise.all(promises).then(responses => {
      const payload = {};
      payload.kikiyx = responses[0];

      if (payload.kikiyx) {
        let items = getResultsArray(payload.kikiyx, 'kikiyx');
        console.log('[AKE DEBUG] Search raw items before validation filter:', items.length);
        items = items.filter(acc => {
          let has = {};
          if (acc.deck_info) {
            try { has = typeof acc.deck_info === 'string' ? JSON.parse(acc.deck_info) : acc.deck_info; }
            catch (e) { }
          } else if (acc.items) {
            acc.items.forEach(it => { has[it.name] = (has[it.name] || 0) + (it.count || 1); });
          }
          return selectedKeys.every(k => {
            const req = selected[k];
            return req.rawNames.some(rn => (has[rn] || 0) >= req.count);
          });
        });
        console.log('[AKE DEBUG] Search items after validation filter:', items.length);
        payload.kikiyx = { results: items };
      }
      renderResults(payload);
    }).catch(e => { console.error('[AKE DEBUG] Search error:', e); res.innerHTML = 'Search failed.'; });
  };

  /* ====== Sorting Logic ====== */
  const calculateAccountTotal = (item) => {
    let total = 0;
    const apiConf = API_SOURCES[item._src];
    if (!apiConf) return 0;

    let has = {};
    if (item.deck_info) {
      try { has = typeof item.deck_info === 'string' ? JSON.parse(item.deck_info) : item.deck_info; } catch (e) { }
    } else if (item.items) {
      item.items.forEach(it => { has[it.name] = (has[it.name] || 0) + (it.count || 1); });
    }

    const prefixes = apiConf.prefixes;
    const unwanted = apiConf.unwanted;

    Object.entries(has).forEach(([name, count]) => {
      const norm = normalizeString(name, prefixes);
      if (!unwanted.has(norm)) {
        total += (parseInt(count) || 0);
      }
    });
    return total;
  };

  const sortResults = () => {
    const sortMode = document.getElementById('sortSelect')?.value || 'default';
    if (sortMode === 'default') {
      allSearchResults.sort((a, b) => (a._p || 0) - (b._p || 0));
    } else {
      allSearchResults.sort((a, b) => {
        const totalA = calculateAccountTotal(a);
        const totalB = calculateAccountTotal(b);
        if (sortMode === 'count_desc') return totalB - totalA;
        if (sortMode === 'count_asc') return totalA - totalB;
        return 0;
      });
    }
    renderedCount = 0;
    document.querySelector("#results").innerHTML = '';
    renderBatch();
  };

  const renderResults = payload => {
    const res = document.querySelector("#results");
    let list = [];
    if (payload.kikiyx) {
      const rawItems = getResultsArray(payload.kikiyx, 'kikiyx');
      const l = rawItems.map(a => ({ ...a, _src: 'kikiyx', _p: API_SOURCES['kikiyx'].priority }));
      list = list.concat(l);
    }

    if (!list.length) return res.innerHTML = '<div class="no-data">No results matching criteria.</div>';

    res.innerHTML = '';
    allSearchResults = list;
    renderedCount = 0;

    const sortMode = document.getElementById('sortSelect')?.value || 'default';
    if (sortMode === 'default') {
      allSearchResults.sort((a, b) => (a._p || 0) - (b._p || 0));
    } else {
      allSearchResults.sort((a, b) => {
        const totalA = calculateAccountTotal(a);
        const totalB = calculateAccountTotal(b);
        if (sortMode === 'count_desc') return totalB - totalA;
        if (sortMode === 'count_asc') return totalA - totalB;
        return 0;
      });
    }

    initResultObserver();
    renderBatch();
  };

  const renderBatch = () => {
    const res = document.querySelector("#results");
    const sentinel = document.getElementById('sentinel');
    if (sentinel) sentinel.remove();

    const batch = allSearchResults.slice(renderedCount, renderedCount + BATCH_SIZE);
    if (!batch.length) return;

    batch.forEach(a => {
      const apiConf = API_SOURCES[a._src];
      let items = Array.isArray(a.items) ? a.items : [];
      if (!items.length && a.deck_info) {
        try {
          const di = typeof a.deck_info === 'string' ? JSON.parse(a.deck_info) : a.deck_info;
          items = Object.entries(di || {}).map(([name, count]) => ({ name, count }));
        } catch (e) { }
      }
      const card = document.createElement('div');
      card.className = 'result-card';
      const rawId = a.code || a.account_id || a.name || a.id || "";
      const displayId = privateToPublicID(rawId, a._src);

      let info = [];
      let emailFound = false;
      let serverName = a.server || 'Unknown';

      if (a._src === 'chushi') {
        const desc = a.description || '';
        const p = desc.split(/[-—–]+/).map(s => s.trim());
        if (p.length >= 3) {
          serverName = p[1];
          info.push("Gender: " + (p[0] === '女' ? 'Female' : (p[0] === '男' ? 'Male' : p[0])));
          info.push("Server: " + serverName);
          info.push("Level: " + p[2]);
        } else if (desc) {
          info.push(desc);
        }
        if (desc.toLowerCase().includes('email')) emailFound = true;
      } else {
        let s = a.server || '', g = '', l = '';
        const di = a.deck_info ? (typeof a.deck_info === 'string' ? JSON.parse(a.deck_info) : a.deck_info) : {};
        Object.keys(di || {}).forEach(k => {
          const normK = normalizeString(k, apiConf.prefixes);
          if (normK === 'America' || normK === 'Europe' || normK === 'Asia' || normK === 'SEA' || normK === 'HMT') {
            if (!s) { s = normK; serverName = normK; }
          }
          if (k.includes('女')) g = 'Female';
          if (k.includes('男')) g = 'Male';
        });
        if (a.server && !s) { s = a.server; serverName = a.server; }
        const src = a.source || '';
        const lm = src.match(/等级[:：]([0-9]+)/);
        if (lm) l = lm[1];
        if (g) info.push("Gender: " + g);
        if (s) info.push("Server: " + translateName(s));
        if (l) info.push("Level: " + l);

        if (src.includes('企业')) { info.push("Email: Enterprise"); emailFound = true; }
        else if (src.includes('微软')) { info.push("Email: Microsoft"); emailFound = true; }
      }

      if (!emailFound) {
        info.push("Email: Microsoft");
      }

      if (!appSettings.hide_source) {
        info.push("Source: " + API_SOURCES[a._src].name);
      }

      const charData = items.filter(c => {
        const n = normalizeString(c.name, apiConf.prefixes);
        // Filter out Server Cards (A-series) and Weapon Cards (W-series)
        if (c.id && (String(c.id).startsWith('A') || String(c.id).startsWith('W') || String(c.id).startsWith('13'))) return false;
        // Filter out Metadata Cards (Gender, Server, etc)
        if (['Gender', 'Server', 'Email', 'Level', '性别', '区服'].some(ignore => n.includes(ignore))) return false;
        return !apiConf.unwanted.has(n);
      }).map(c => {
        const raw = c.name;
        const norm = normalizeString(raw, apiConf.prefixes);
        const std = translateName(norm);
        const cImg = getCustomImage(norm) || getCustomImage(std) || getCustomImage(raw);
        const img = cImg || c.img_url || c.role_img || window._characterImageMap?.[std] || '';
        return {
          html: `<div class="char"><img src="${img}" alt="${std}" onerror="this.style.opacity=.5" />
                    <div class="cname">${std}</div>${c.count > 1 ? '<div class="char-count">x' + c.count + '</div>' : ''}
                  </div>`,
          name: std,
          count: c.count || 1
        };
      });

      const charString = charData.flatMap(c => Array(c.count).fill(c.name)).join(',');
      const extendedId = `${displayId}----${serverName}----[${charString}]`;

      card.innerHTML = `<div class="result-header">
                    <div>Account ID: <strong>${escapeHtml(displayId)}</strong></div>
                    <div class="header-btns">
                      <button class="copy-btn">Copy ID</button>
                      <button class="price-btn">Price Check</button>
                    </div>
                  </div>
                  <div class="result-info">${info.join(' | ')}</div>
                  <div class="chars-row">${charData.map(c => c.html).join('')}</div>`;

      card.querySelector('.copy-btn').onclick = () => window.copyToClipboard(extendedId);
      card.querySelector('.price-btn').onclick = () => window.showPriceCheck(displayId, extendedId);

      res.appendChild(card);
    });

    renderedCount += batch.length;
    if (renderedCount < allSearchResults.length) {
      const s = document.createElement('div');
      s.id = 'sentinel';
      s.style.height = '100px';
      s.innerHTML = '<div style="text-align:center; padding: 20px; color: var(--text-muted);">Loading more results...</div>';
      res.appendChild(s);
      resultObserver.observe(s);
    }
  };

  const initPriceModal = () => {
    const modal = document.createElement('div');
    modal.id = 'priceCheckModal';
    modal.className = 'modal-backdrop hidden';
    modal.innerHTML = `
                    <div class="modal-content">
                      <div class="modal-header">
                        <h3>Price Check Inquiry</h3>
                        <button class="close-modal">&times;</button>
                      </div>
                      <div class="modal-body">
                        <p class="step-header">Step 1: Copy Account ID</p>
                        <div class="id-display-box highlighted">
                          <span>Account ID:</span>
                          <code id="modalAccountId">---</code>
                          <input type="hidden" id="modalFullId" value="">
                          <button class="copy-mini-btn" id="modalCopyBtn">Copy</button>
                        </div>

                        <div class="modal-divider"></div>

                        <p class="step-header">Step 2: Choose Contact Method For Price Quotation</p>

                        <div class="contact-row">
                          <div class="contact-option primary">
                            <div class="opt-icon">✨</div>
                            <div class="opt-details">
                              <strong>Direct Message</strong>
                              <a href="https://discord.com/users/477359052662243349" target="_blank"
                                class="modal-btn">DM Admin</a>
                            </div>
                          </div>

                          <div class="contact-option secondary">
                            <div class="opt-icon">🌸</div>
                            <div class="opt-details">
                              <strong>Join Server</strong>
                              <a href="https://discord.com/invite/exvg8GR8sk" target="_blank" class="modal-btn">Join &
                                DM CL</a>
                            </div>
                          </div>
                        </div>
                        <p class="modal-hint"
                          style="text-align:center; margin-top:8px; font-size:0.8em; color:var(--text-muted); opacity:0.8;">
                          (Discord Tag: <code>gachamacha2025</code>)
                        </p>
                      </div>
                    </div>
                    `;
    document.body.appendChild(modal);

    const closeBtn = modal.querySelector('.close-modal');
    closeBtn.onclick = () => modal.classList.add('hidden');
    modal.onclick = (e) => {
      if (e.target === modal) modal.classList.add('hidden');
    };

    const cpBtn = modal.querySelector('#modalCopyBtn');
    cpBtn.onclick = () => {
      const fullId = document.querySelector('#modalFullId').value;
      copyToClipboard(fullId);
      cpBtn.textContent = 'Copied!';
      setTimeout(() => cpBtn.textContent = 'Copy', 2000);
    };
  };

  window.showPriceCheck = (id, fullId) => {
    const modal = document.querySelector("#priceCheckModal");
    if (!modal) return;
    document.querySelector("#modalAccountId").textContent = id;
    document.querySelector("#modalFullId").value = fullId || id;
    modal.classList.remove('hidden');
  };

  const sBtn = document.querySelector("#searchBtn");
  if (sBtn) sBtn.onclick = performSearch;

  const sortSel = document.querySelector("#sortSelect");
  if (sortSel) sortSel.onchange = sortResults;

  const cBtn = document.querySelector("#clearBtn");
  if (cBtn) cBtn.onclick = () => {
    selected = {};
    document.querySelectorAll('.thumb').forEach(t => {
      t.classList.remove('selected');
      t.querySelector('.count-badge')?.remove();
    });
    const idIn = document.querySelector("#idSearchInput");
    if (idIn) idIn.value = '';
    updateSelectedUI();
    document.querySelector("#results").innerHTML = '';
  };

  window.copyToClipboard = copyToClipboard;
  initPriceModal();
  loadResources();
})();